import React from 'react'
import {
  theme,
  ThemeColors
} from '@contrast-security-inc/design-system-foundations'
import { css, cx } from '@emotion/css'
import { ellipsis } from 'polished'
import { CsDropdownExpandIcon, CsDropdownCollapseIcon } from '../icons'

interface SelectionProps {
  readonly children: React.ReactChild
  readonly isOpen: boolean
  readonly containerCss?: string
  readonly openContainerCss?: string
  readonly textCss?: string
  readonly arrowColor?: ThemeColors
  readonly hideArrow?: boolean
  readonly e2eTestId?: string
}

const defaultContainerCss = css`
  padding: 0 10px 0;
  height: 34px;
  border-radius: 1px;
  border-width: 1px;
  border-style: solid;
  display: flex;
  align-items: center;
  background-image: linear-gradient(
    180deg,
    ${theme.color.white},
    ${theme.color.neutral10}
  );
  border-color: ${theme.color.neutral40};
`

const flexChildCss = css`
  min-width: 0;
`

const selectionTextContainerCss = cx(
  flexChildCss,
  css`
    flex: 1 1 auto;
  `
)

const arrowContainerCss = cx(
  flexChildCss,
  css`
    display: flex;
    flex: none;
    margin-left: 2px;
  `
)

const selectionTextCss = css`
  ${ellipsis()};
  display: inherit;
  user-select: none;
`

export function Selection({
  children,
  isOpen,
  containerCss,
  openContainerCss,
  textCss,
  arrowColor = 'neutral90',
  hideArrow = false,
  e2eTestId,
  ...rest
}: SelectionProps) {
  return (
    <div
      data-e2e={e2eTestId}
      className={cx(
        'legacy-ds-dropdown-selection',
        defaultContainerCss,
        containerCss,
        !!openContainerCss && isOpen ? openContainerCss : undefined
      )}
      {...rest}
    >
      <div data-e2e="header-dropdown" className={selectionTextContainerCss}>
        <div className={cx(textCss, selectionTextCss)}>{children}</div>
      </div>
      {!hideArrow && (
        <div className={arrowContainerCss}>
          {isOpen ? (
            <CsDropdownCollapseIcon color={arrowColor} />
          ) : (
            <CsDropdownExpandIcon color={arrowColor} />
          )}
        </div>
      )}
    </div>
  )
}
